var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list",class:_vm.type},_vm._l((_vm.list),function(ref,index){
var imageUrl = ref.imageUrl;
var title = ref.title;
var description = ref.description;
var number = ref.number;
return _c('li',{key:index,staticClass:"item"},[(imageUrl)?_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":imageUrl,"alt":""}})]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(title))]),(number)?_c('div',{staticClass:"num"},[_vm._v("— №"+_vm._s(number)+" —")]):_vm._e(),_c('div',{staticClass:"description"},[_vm._v(_vm._s(description))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }